import { createFileRoute, Navigate, useRouter } from "@tanstack/react-router";

import { validateIndex } from "@/app/routeValidation";
import { HotelGallery } from "@/features/hotels/components/hotel/HotelGallery";
import { useHotelDataContext } from "@/features/hotels/contexts/HotelDataContext";

export const Route = createFileRoute(
  "/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images_/fullscreen",
)({
  validateSearch: validateIndex,
  component: RouteComponent,
  staticData: {
    hotelStep: {
      presentationMode: "modal",
      stepNumber: 1,
    },
    drawer: false,
  },
});

function RouteComponent() {
  const { index } = Route.useSearch();
  const router = useRouter();
  const { data: hotel } = useHotelDataContext();

  if (!hotel) {
    // If the app fails to load the hotel data or to pass search data, redirect to the hotel list page
    // This is a fallback in case the user tries to access this page directly
    // It's unlikely that this will happen, but it's a good fallback to have
    // Avoids the need to handle these cases in the other components
    return <Navigate to=".." from={Route.fullPath} />;
  }

  return (
    <HotelGallery
      images={hotel.imagesUrls.map((url) => ({ url, name: hotel.name }))}
      initialIndex={index}
      onBackClick={() => router.history.back()}
    />
  );
}
